module.exports = __webpack_public_path__ + "img/via.c4497dfe.svg";